import * as PIXI from "pixi.js";
import data from "../configs/data";
import {Button} from "../controlElements/Button";
import {CustomSpineAnimation} from "../CustomSpineAnimation";
import {AutoPlayButton} from "./AutoPlayButton";

export class SpinButton extends PIXI.Container {

    private autoPlayButton: AutoPlayButton;
    private spinButton: Button;
    private loadingAnimation: CustomSpineAnimation;

    private readonly SPIN_LOAD_ANIMATION_CONFIG = {
        NAME: "spinButtonLoad",
        STATES: {
            IDLE: "idle",
            LOADING: "loading",
        },
        SLOT_CONTAINERS: {
            BUTTON: "button",
        },
    };

    constructor() {
        super();
        this.createLoadingAnimation();
        this.createAndAddSpinButton();
        this.createAndAddAutoPlayButton();
        this.changeToSpinButton();
    }

    public changeToSpinButton(): void {
        this.autoPlayButton.visible = false;
        this.spinButton.visible = true;
    }

    public setSpinsLeftValue(amount: number): void {
        if (amount === 0) {
            this.autoPlayButton.visible = false;
            this.spinButton.visible = true;
        } else {
            this.autoPlayButton.visible = true;
            this.spinButton.visible = false;
            this.autoPlayButton.setSpinsLeftValue(amount);
        }
    }

    public subscribeOnClicked(subscriber: Function): void {
        this.spinButton.subscribeOnClicked(subscriber);
        this.autoPlayButton.subscribeOnClicked(subscriber);
    }

    public enable(): void {
        this.spinButton.enabled = true;
        this.autoPlayButton.enabled = true;
    }

    public disable(): void {
        this.spinButton.enabled = false;
        this.autoPlayButton.enabled = false;
    }

    public playLoadingAnimation(): void {
        this.loadingAnimation.play(this.SPIN_LOAD_ANIMATION_CONFIG.STATES.LOADING, true);
    }

    public playIdleAnimation(): void {
        this.loadingAnimation.play(this.SPIN_LOAD_ANIMATION_CONFIG.STATES.IDLE);
    }

    private createLoadingAnimation(): void {
        this.loadingAnimation = new CustomSpineAnimation(this.SPIN_LOAD_ANIMATION_CONFIG.NAME);
        this.loadingAnimation.getSlotContainer(this.SPIN_LOAD_ANIMATION_CONFIG.SLOT_CONTAINERS.BUTTON, true);
        this.addChild(this.loadingAnimation);
    }

    private createAndAddSpinButton(): void {
        this.spinButton = new Button(data.images.spinButtonBase, data.images.spinButtonHover,
            data.images.spinButtonClick, data.images.spinButtonInActive, data.audios.buttonSpinClicked);
        this.spinButton.scale.y = -1;
        this.loadingAnimation.getSlotContainer(this.SPIN_LOAD_ANIMATION_CONFIG.SLOT_CONTAINERS.BUTTON)
            .addChild(this.spinButton);
    }

    private createAndAddAutoPlayButton(): void {
        this.autoPlayButton = new AutoPlayButton(data.images.autoSpinButtonBase, data.images.autoSpinButtonHover,
            data.images.autoSpinButtonClick, data.images.autoSpinButtonInActive, data.audios.buttonSpinClicked);
        this.autoPlayButton.scale.y = -1;
        this.loadingAnimation.getSlotContainer(this.SPIN_LOAD_ANIMATION_CONFIG.SLOT_CONTAINERS.BUTTON)
            .addChild(this.autoPlayButton);
    }
}



// WEBPACK FOOTER //
// ./src/app/userInterface/SpinButton.ts